import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import PartnersSection from "@/components/PartnersSection";
import Footer from "@/components/Footer";

const Cases = () => {
  useEffect(() => {
    document.title = "Кейсы AI-трансформации | WMT AI";
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navbar />
      <main className="pt-16">
        <PartnersSection layout="grid" headingAs="h1" headingVariant="page" />
      </main>
      <Footer />
    </div>
  );
};

export default Cases;
